import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Typography } from '@mui/material';
var NUGGET_STRINGS = appStrings.modules.nugget;
export var NuggetEvent = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'SMALL') {
        return (_jsxs(Typography, { variant: "body1", sx: bottomTextStyle, children: [_jsx(Typography, { fontWeight: "bold", children: NUGGET_STRINGS.eventSubtext }), variant.date] }));
    }
    return _jsx(_Fragment, {});
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '20px',
    flexDirection: 'row',
    display: 'flex',
    mt: 3,
};
